export default __webpack_public_path__ + "static/Answer, summarise, prioritise-fb75cd517c54eadc5075d1d9ca40ec30.png";